<div class="pol-container">
  <main>
    <section>
      <ng-container *ngIf="pageView === 'Unauthorized' &&  !memberUnauthorized">
        <p>You are not authorized to view this content.</p>
      </ng-container>
      <ng-container *ngIf="pageView === 'Unauthorized' &&  memberUnauthorized === 'Unauthorized'">
        <p>You are not authorized to {{unauthorizedPageName}}.  Contact your <a routerLink="/user/my-oaa">Online Account Administrator (OAA)</a> to request additional access.</p>
      </ng-container>
      <ng-container *ngIf="pageView === 'SignInError'">
        <p>The requested page is currently unavailable.</p>
        <p>Please close the tab and select the function again or call Provider Services at 1-866-918-1595 to report this problem if it persists.</p>
        @if(hasErrorInfo) {
          <details style="text-align: left">
            <summary>More details</summary>
            <p *ngIf="error">Error: {{ error }}</p>
            <p *ngIf="errorDescription">Description: {{ errorDescription }}</p>
            <p *ngIf="state">State: {{ state }}</p>
            <p *ngIf="uri">URI: {{ uri }}</p>
          </details>
        }
      </ng-container>
    </section>
  </main>
</div>
